import { Component, OnInit } from '@angular/core';
import {CoreConfig} from "../../../core/core.config";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor(
      public coreConfig: CoreConfig,
  ) { }

  ngOnInit(): void {
  }

  /**
   * Extracts the base URL path from a URL string without query parameters
   * @param url The full URL string that might contain query parameters
   * @returns The base URL path
   */
  getReleaseLogUrl(url: string): string|null {
    if (!url) return null;

    // If URL contains query parameters, extract just the path
    const queryParamIndex = url.indexOf('?');
    return queryParamIndex >= 0 ? url.substring(0, queryParamIndex) : url;
  }

  /**
   * Extracts query parameters from a URL string and returns them as an object
   * @param url The full URL string that might contain query parameters
   * @returns An object containing the query parameters
   */
  getReleaseLogParams(url: string): { [key: string]: string }|null {
    if (!url || !url.includes('?')) return null;

    // Extract the query string and convert to an object
    const queryString = url.substring(url.indexOf('?') + 1);
    const params: { [key: string]: string } = {};

    new URLSearchParams(queryString).forEach((value, key) => {
      params[key] = value;
    });

    return params;
  }

}
